export const COLUMNS_HEADERS = [{id: 'title', key: 'title', label: 'Title'}];

export const RECORDS_PER_PAGE = 20;

export const DEFAULT_FORM_VALUES = {
  title: '',
  descriptionEn: {},
  descriptionNl: {},
  stops: [],
  productId: null,
};
